<template>
  <div>
    <!-- 订单列表 -->
    <div class="sub" v-if="!isRefund">
      <div class="list">
        <div class="findList">
          <div class="intKuang">
            <keyboard-input
              field="obj.searchVal"
              :value="obj.searchVal"
              clearable
              placeholder="请输入会员手机号或订单编号"
              @inputChange="formItemChange"
            ></keyboard-input>
          </div>
          <div class="choose" @click="chooseDia = true">
            <img style="width: 16px" src="../assets/icon-choose.png" alt="" />
            <span>筛选</span>
          </div>
        </div>
        <div class="orderList">
          <div
            v-if="orderList.length === 0"
            style="text-align: center; margin-top: 50px; color: #909399"
          >
            暂无数据
          </div>
          <ul
            class="infinite-list"
            v-infinite-scroll="load"
            style="height: calc(100vh - 74px)"
          >
            <li
              v-for="(item, index) in orderList"
              :key="item.id"
              :class="{ clickColor: index == clickIndex }"
              @click="changeOrder(index)"
              class="infinite-list-item"
            >
              <p class="itemTop">
                <img
                  style="width: 73px"
                  src="../assets/icon-finsh.png"
                  alt=""
                  v-if="item.status == 1"
                />
                <img
                  style="width: 73px"
                  src="../assets/icon-part.png"
                  alt=""
                  v-if="item.status == 2"
                />
                <img
                  style="width: 73px"
                  src="../assets/icon-refund.png"
                  alt=""
                  v-if="item.status == 3"
                />
                <span>订单编号：{{ item.ord_bh }}</span>
              </p>
              <p class="itemMiddel">会员账号:{{ item.member_mobile }}</p>
              <p class="itemButtom">
                <span class="num">共{{ item.buy_num }}件</span>
                <span class="price">￥{{ item.pay_price }}</span>
                <span class="time">
                  <img
                    style="width: 14px"
                    src="../assets/icon-time.png"
                    alt=""
                  />
                  <!-- time() -->
                  <span>{{ item.add_time }}</span>
                </span>
              </p>
            </li>
          </ul>

          <!-- <ul>
            <li v-for="(item, index) in orderList" :key="item.id" :class="{ clickColor: index == clickIndex }"
              @click="changeOrder(index)">
              <p class="itemTop">
                <img src="../assets/icon-finsh.jpg" alt="" v-if="item.status == 1" />
                <img src="../assets/icon-part.jpg" alt="" v-if="item.status == 2" />
                <img src="../assets/icon-refund.jpg" alt="" v-if="item.status == 3" />
                <span>订单编号：{{ item.ord_bh }}</span>
              </p>
              <p class="itemMiddel">会员账号:{{ item.member_id }}</p>
              <p class="itemButtom">
                <span class="num">共{{ item.buy_num }}件</span>
                <span class="price">￥{{ item.pay_price }}</span>
                <span class="time">
                  <img src="../assets/icon-time.jpg" alt="" />
                  <span>{{ time(item.add_time) }}</span>
                </span>
              </p>
            </li>
          </ul> -->
        </div>
        <div class="page" style="display: flex; justify-content: space-between">
          <div v-if="page.curpage < page.totalPage" @click="next">下一页</div>
          <span>第{{ page.curpage }}页</span>
          <span>共{{ page.totalPage }}页</span>
        </div>
      </div>
      <div class="goodsDetail">
        <div class="detailTop">
          <img
            style="width: 108px"
            v-if="curOrder.status == 1"
            src="../assets/icon-finshBig.png"
            alt=""
          />
          <img
            style="width: 108px"
            v-if="curOrder.status == 2"
            src="../assets/icon-partBig.png"
            alt=""
          />
          <img
            style="width: 108px"
            v-if="curOrder.status == 3"
            src="../assets/icon-refundBig.png"
            alt=""
          />
          <span style="margin-left: 10px">订单号: {{ curOrder.ord_bh }}</span>
          <span>收银员:{{ curOrder.cashier_name }}</span>
          <span
            >下单时间:{{
              curOrder && curOrder.pay_time ? time(curOrder.pay_time) : ""
            }}</span
          >
        </div>
        <div class="detailInfo">
          <el-row>
            <el-col :span="11">
              <div class="leftInfo">
                <div class="tit">商品信息</div>
                <ul>
                  <li
                    v-for="(item, index) in curOrder.api_items"
                    :key="item.id"
                  >
                    <div class="goodsImg">
                      <img
                        :src="item.original_img"
                      />
                    </div>
                    <div class="goodsInfo">
                      <p class="name">{{ item.goods_name }}</p>
                      <p class="price">
                        单价：¥{{ item.single_price }}/{{ item.unit }}
                      </p>
                      <p class="heavy">
                        重量/数量：
                        {{ item.buy_num }}
                        {{ item.unit }}
                      </p>
                    </div>
                    <div class="goodsPrice">¥ {{ item.sum_money }}</div>
                  </li>
                </ul>
              </div>
            </el-col>
            <el-col :span="2">
              <div class="shu"></div>
            </el-col>
            <el-col :span="11" :offset="1">
              <div class="rightInfo" v-if="curDetai.order">
                <div class="tit">结算信息</div>
                <div class="order">
                  <el-row style="margin-bottom: 6px">
                    <el-col :span="10"
                      ><span
                        class="oKey"
                        style="color: #1f2d23; font-weight: 600"
                        >订单实付</span
                      ></el-col
                    >
                    <el-col
                      :span="12"
                      style="color: @desk-font-color; font-weight: 600;font-size;16px"
                      ><span class="oVal"
                        >¥ {{ curDetai.order.pay_price }}</span
                      ></el-col
                    >
                  </el-row>
                  <el-row>
                    <el-col :span="10"
                      ><span class="oKey">付款方式</span></el-col
                    >
                    <el-col :span="12">
                      <span class="oVal">{{
                        curDetai.order.pay_type === "balance"
                          ? "余额"
                          : curDetai.order.pay_type === "wechat"
                          ? "微信"
                          : curDetai.order.pay_type === "alipay"
                          ? "支付宝"
                          : curDetai.order.pay_type === "cash"
                          ? "现金"
                          : ""
                      }}</span></el-col
                    >
                  </el-row>
                </div>
                <div class="discounts">
                  <el-row style="margin-bottom: 6px">
                    <el-col :span="10"
                      ><span
                        class="oKey"
                        style="color: #1f2d23; font-weight: 600"
                        >优惠合计</span
                      ></el-col
                    >
                    <el-col :span="12"
                      ><span class="oVal"
                        >¥ {{ curDetai.order.order_discount_money }}</span
                      ></el-col
                    >
                  </el-row>
                  <el-row style="margin-bottom: 6px">
                    <el-col :span="10"><span class="oKey">优惠券</span></el-col>
                    <el-col :span="12"
                      ><span class="oVal"
                        >¥ {{ curDetai.order.coupon_money }}</span
                      ></el-col
                    >
                  </el-row>
                  <el-row style="margin-bottom: 6px">
                    <el-col :span="10"><span class="oKey">折扣</span></el-col>
                    <el-col :span="12"
                      ><span class="oVal">{{
                        curDetai.order.order_discount
                          ? curDetai.order.order_discount
                          : "-"
                      }}</span></el-col
                    >
                  </el-row>
                  <el-row>
                    <el-col :span="10"><span class="oKey">抹零</span></el-col>
                    <el-col :span="12"
                      ><span class="oVal"
                        >¥ {{ curDetai.order.zero_money }}</span
                      ></el-col
                    >
                  </el-row>
                </div>
                <div class="member">
                  <p class="oTit"><span class="oKey">会员信息</span></p>
                  <el-row style="margin-bottom: 6px">
                    <el-col :span="10"
                      ><span class="oKey">会员手机</span></el-col
                    >
                    <el-col :span="12"
                      ><span class="oVal">{{
                        curDetai.member.mobile
                      }}</span></el-col
                    >
                  </el-row>
                  <el-row style="margin-bottom: 6px">
                    <el-col :span="10"
                      ><span class="oKey">会员余额</span></el-col
                    >
                    <el-col :span="12"
                      ><span class="oVal"
                        >¥ {{ curDetai.member.money }}</span
                      ></el-col
                    >
                  </el-row>
                  <el-row style="margin-bottom: 6px">
                    <el-col :span="10"
                      ><span class="oKey">剩余积分</span></el-col
                    >
                    <el-col :span="12"
                      ><span class="oVal">{{
                        curDetai.member ? curDetai.member.score : "0"
                      }}</span></el-col
                    >
                  </el-row>
                </div>
                <div class="refund" v-if="refundItem.length > 0">
                  <p class="oTit"><span class="oKey">退款信息</span></p>
                  <div v-for="item in refundItem" :key="item.id">
                    <p>
                      <span class="oKey">退款商品</span>
                      <span class="oVal">{{ item.goods_name }}</span>
                    </p>
                    <p>
                      <span class="oKey">退款金额</span>
                      <span class="oVal">¥ {{ item.refund_money }}</span>
                    </p>
                    <p>
                      <span class="oKey">退款方式</span>
                      <span class="oVal">{{
                        item.refund_way === 1
                          ? "原路退回"
                          : item.refund_way === 2
                          ? "现金"
                          : ""
                      }}</span>
                    </p>
                    <p>
                      <span class="oKey">退款原因</span>
                      <span class="oVal"> {{ item.reason }}</span>
                    </p>
                    <p>
                      <span class="oKey">退款时间</span>
                      <span class="oVal">{{ time(item.refund_time) }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="handle">
          <button @click="printInfo">打印</button>
          <button
            v-if="curOrder.status === 1 || curOrder.status === 2"
            @click="isRefund = true"
          >
            退款
          </button>
        </div>
      </div>
    </div>
    <!-- 退款 -->
    <div class="refundSub" v-if="isRefund">
      <div class="refundLeft">
        <el-table
          :data="activeItem"
          stripe
          style="width: 100%"
          @select="selectOne"
          @select-all="selectOne"
        >
          <template slot-scope="scope">
            <el-table-column type="selection" width="50" prop="status">
            </el-table-column>
            <el-table-column
              label="商品名称"
              width="305"
              prop="goods_name"
            ></el-table-column>
            <el-table-column
              label="退款金额"
              width="80"
              prop="sale_sum_money"
            ></el-table-column>
          </template>
        </el-table>
      </div>
      <div class="refundright">
        <div class="oheader">
          <div class="detailHead">
            <ul>
              <li>订单号：{{ curDetai.order.ord_bh }}</li>
              <li>下单时间：{{ time(curDetai.order.pay_time) }}</li>
              <li>收银员：{{ curDetai.order.cashier_id }}</li>
              <li>订单实付：¥{{ curDetai.order.pay_price }}</li>
              <li>
                付款方式：{{
                  curDetai.order.pay_type === "balance"
                    ? "余额"
                    : curDetai.order.pay_type === "wechat"
                    ? "微信"
                    : curDetai.order.pay_type === "alipay"
                    ? "支付宝"
                    : curDetai.order.pay_type === "cash"
                    ? "现金"
                    : ""
                }}
              </li>
            </ul>
          </div>
          <div class="detailBody">
            <ul>
              <li>
                <p class="tit">退款总金额</p>
                <p class="money" style="font-size: 16px">
                  <keyboard-input
                    field="finalmoney"
                    :value="finalmoney"
                    clearable
                    @inputChange="formItemChange"
                  >
                  </keyboard-input>
                </p>
              </li>
              <li>
                <p class="tit">退款方式</p>
                <el-radio-group v-model="radio1">
                  <el-radio :label="3">原路退回</el-radio>
                </el-radio-group>
              </li>
              <li>
                <p class="tit">退款类型</p>
                <el-radio-group v-model="radio">
                  <el-radio :label="1">退货退款</el-radio>
                  <el-radio :label="2">仅退款</el-radio>
                </el-radio-group>
              </li>
              <li>
                <p class="tit">退款原因</p>
                <el-radio-group v-model="checkList">
                  <el-radio label="商品质量问题">商品质量问题</el-radio>
                  <el-radio label="点错商品">点错商品</el-radio>
                  <el-radio label="其他原因">其他原因</el-radio>
                </el-radio-group>
              </li>
              <li>
                <p class="tit">备注</p>
                <keyboard-input
                  type="textarea"
                  field="refund.textarea"
                  :value="refund.textarea"
                  clearable
                  @inputChange="formItemChange"
                  placeholder="请输入内容"
                >
                </keyboard-input>
              </li>
            </ul>
          </div>
        </div>
        <div class="detailFooter">
          <button class="cancel" @click="isRefund = false">取消</button>
          <button class="affirm" @click="confirm">确认退款</button>
        </div>
      </div>
    </div>
    <!-- 筛选弹框 -->
    <el-dialog
      title="订单筛选"
      width="373px"
      :visible.sync="chooseDia"
      @closed="closeFilter"
    >
      <div class="chooseDia">
        <div class="tit">下单时间</div>
        <el-date-picker
          v-model="obj.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="dayFil = ''"
          style="width: 325px; margin-bottom: 10px"
        >
        </el-date-picker>
        <el-radio-group
          style="margin-bottom: 30px"
          v-model="dayFil"
          @change="obj.time = []"
        >
          <el-radio-button label="1">今日</el-radio-button>
          <el-radio-button label="2">昨日</el-radio-button>
          <el-radio-button label="3">本周</el-radio-button>
          <el-radio-button label="4">本月</el-radio-button>
        </el-radio-group>

        <div class="tit">订单状态</div>
        <el-radio-group style="margin-bottom: 30px" v-model="obj.status">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="1">已完成</el-radio-button>
          <el-radio-button label="2">部分退</el-radio-button>
          <el-radio-button label="3">整单退</el-radio-button>
        </el-radio-group>
        <!-- <el-row>
          <el-button @click="closeFilter">取消</el-button>
          <el-button type="primary" @click="search">确定</el-button>
        </el-row> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeFilter">取消</el-button>
        <el-button type="primary" @click="search">确定</el-button>
      </span>
    </el-dialog>
    <div class="print-box" id="print-box" v-if="showPrint">
      <div class="print-title">订单小票</div>
      <div class="print-out border-b">
        <div class="item-print">
          <div class="print-label">下单时间:</div>
          <div class="print-content" style="transform: translateX(-10px)">
            {{ time(curDetai.order.pay_time) }}
          </div>
        </div>
        <div class="item-print">
          <div class="print-label">订单号：</div>
          <div class="print-content" style="transform: translateX(-10px)">
            {{ curDetai.order.ord_bh }}
          </div>
        </div>
        <div class="item-print">
          <div class="print-label">收银员：</div>
          <div class="print-content" style="transform: translateX(-10px)">
            {{ curOrder.cashier_name }}
          </div>
        </div>
      </div>
      <div class="print-out border-b">
        <div class="item-print">
          <div class="print-label">商品信息</div>
        </div>
        <div
          class="item-print"
          style="display: flex; justify-content: space-between; width: 100%"
        >
          <div style="width: 40%; text-align: center">商品名称</div>
          <div style="width: 20%; text-align: center">单价</div>
          <div style="width: 20%; text-align: center">重量/数量</div>
          <div style="width: 20%; text-align: center">小计</div>
        </div>
        <div
          class="item-print"
          v-for="(item, index) in curOrder.api_items"
          :key="item.id"
          style="display: flex; justify-content: space-between"
        >
          <div style="width: 40%; text-align: center">
            {{ item.goods_name }}
          </div>
          <div style="width: 20%; text-align: center">
            ¥{{ item.single_price }}/{{ item.unit }}
          </div>
          <div style="width: 20%; text-align: center">
            {{ item.buy_num }}
            {{ item.unit }}
          </div>
          <div style="width: 20%; text-align: center">{{ item.sum_money }}</div>
        </div>
      </div>
      <div class="print-out border-b">
        <div class="item-print">
          <div class="print-label">结算信息</div>
        </div>
        <div class="rightInfo" v-if="curDetai.order">
          <div class="order">
            <el-row style="margin-bottom: 6px">
              <el-col :span="10"
                ><span class="oKey" style="color: #1f2d23; font-weight: 600"
                  >订单实付</span
                ></el-col
              >
              <el-col
                :span="12"
                style="color: @desk-font-color; font-weight: 600;font-size;16px"
                ><span class="oVal"
                  >¥ {{ curDetai.order.pay_price }}</span
                ></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="10"><span class="oKey">付款方式</span></el-col>
              <el-col :span="12">
                <span class="oVal">{{
                  curDetai.order.pay_type === "balance"
                    ? "余额"
                    : curDetai.order.pay_type === "wechat"
                    ? "微信"
                    : curDetai.order.pay_type === "alipay"
                    ? "支付宝"
                    : curDetai.order.pay_type === "cash"
                    ? "现金"
                    : ""
                }}</span></el-col
              >
            </el-row>
          </div>
          <div class="discounts">
            <el-row style="margin-bottom: 6px">
              <el-col :span="10"
                ><span class="oKey" style="color: #1f2d23; font-weight: 600"
                  >优惠合计</span
                ></el-col
              >
              <el-col :span="12"
                ><span class="oVal"
                  >¥ {{ curDetai.order.order_discount_money }}</span
                ></el-col
              >
            </el-row>
            <el-row style="margin-bottom: 6px">
              <el-col :span="10"><span class="oKey">优惠券</span></el-col>
              <el-col :span="12"
                ><span class="oVal"
                  >¥ {{ curDetai.order.coupon_money }}</span
                ></el-col
              >
            </el-row>
            <el-row style="margin-bottom: 6px">
              <el-col :span="10"><span class="oKey">折扣</span></el-col>
              <el-col :span="12"
                ><span class="oVal">{{
                  curDetai.order.order_discount
                    ? curDetai.order.order_discount
                    : "-"
                }}</span></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="10"><span class="oKey">抹零</span></el-col>
              <el-col :span="12"
                ><span class="oVal"
                  >¥ {{ curDetai.order.zero_money }}</span
                ></el-col
              >
            </el-row>
          </div>
          <div class="member">
            <p class="oTit"><span class="oKey">会员信息</span></p>
            <el-row style="margin-bottom: 6px">
              <el-col :span="10"><span class="oKey">会员手机</span></el-col>
              <el-col :span="12"
                ><span class="oVal">{{ curDetai.member.mobile }}</span></el-col
              >
            </el-row>
            <el-row style="margin-bottom: 6px">
              <el-col :span="10"><span class="oKey">会员余额</span></el-col>
              <el-col :span="12"
                ><span class="oVal">¥ {{ curDetai.member.money }}</span></el-col
              >
            </el-row>
            <el-row style="margin-bottom: 6px">
              <el-col :span="10"><span class="oKey">剩余积分</span></el-col>
              <el-col :span="12"
                ><span class="oVal">{{
                  curDetai.member ? curDetai.member.score : "0"
                }}</span></el-col
              >
            </el-row>
          </div>
          <div class="item-print" style="border-top: 1px solid #000">
            <div class="print-label">退款信息</div>
          </div>
          <div class="refund" v-if="refundItem.length > 0">
            <div
              v-for="item in refundItem"
              :key="item.id"
              style="border-bottom: 1px solid #000"
            >
              <p>
                <span class="oKey">退款商品</span>
                <span class="oVal">{{ item.goods_name }}</span>
              </p>
              <p>
                <span class="oKey">退款金额</span>
                <span class="oVal">¥ {{ item.refund_money }}</span>
              </p>
              <p>
                <span class="oKey">退款方式</span>
                <span class="oVal">{{
                  item.refund_way === 1
                    ? "原路退回"
                    : item.refund_way === 2
                    ? "现金"
                    : ""
                }}</span>
              </p>
              <p>
                <span class="oKey">退款原因</span>
                <span class="oVal"> {{ item.reason }}</span>
              </p>
              <p>
                <span class="oKey">退款时间</span>
                <span class="oVal">{{ time(item.refund_time) }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getOrderList,
  getOrderDetail,
  refund,
  getColorConfig
} from "../api/index";
import domToImage from "dom-to-image";
import html2canvas from "html2canvas";
import { Loading } from "element-ui";

import { tiaoma } from "@/utils/dataJSon.js";
import { getReceiptField } from "@/api/system-set";
import dayjs from "dayjs";
// console.log('dayjs',dayjs);
// let td = dayjs().format('YYYY-MM-DD HH:mm:ss')
// console.log(td)
// 整体订单：0：待付款  1：完成   2：部分退款   3：全额退款   4：取消 5：关闭订单 6：支付失败
//订单中单个商品：0：待付款  1：完成   2：退款中  3：退款完成   4：订单取消  5：关闭订单
export default {
  data() {
    return {
      finalmoney: 0,
      showPrint: false,
      checkedColor: "#000", // 选中时的颜色,主体颜色
      isRefund: false, //是否退款
      radio: 1,
      checkList: "商品质量问题",
      chooseDia: false,
      dayFil: "",
      orderList: [],
      clickIndex: 0,
      detailInfo: {
        status: 1
      },
      value1: "",
      curOrder: {},
      curDetai: {},
      obj: {
        searchVal: "",
        time: [],
        status: ""
      },
      duration: [],
      refund: { textarea: "" },
      select: [],
      radio1: 3,
      count: 0,
      page: {
        totalPage: 0,
        curpage: 1,
        size: 10
      },
      form: {},
      header: { mark: "表头", boxList: [] },
      goods: { mark: "商品基础信息", boxList: [] },
      settle: { mark: "结算信息", boxList: [] },
      pay: { mark: "支付信息", boxList: [] },
      other: { mark: "其他信息", boxList: [] }
    };
  },
  computed: {
    time() {
      return t => {
        return dayjs(t * 1000).format("YYYY-MM-DD HH:mm:ss");
      };
    },
    money() {
      return this.select.reduce((prev, cur) => {
        if (
          Number(prev) + Number(cur.sale_sum_money) >
          Number(this.curDetai.order.pay_price)
        ) {
          return Number(this.curDetai.order.pay_price);
        } else {
          return Number(prev) + Number(cur.sale_sum_money);
        }
      }, 0);
    },
    //已退款项
    refundItem() {
      return this.curDetai.items.filter(i => {
        return i.status === 2 || i.status === 3;
      });
    },
    //可退款项
    activeItem() {
      console.log(this.curDetai, "this.curDetai");
      // debugger;
      return this.curDetai.items.filter(i => {
        return i.status === 1;
      });
    }
  },
  created() {
    //获取所有订单
    this.getAllOrder(this.page);
    this.getColorConfig();
    this.getPrinterName();
  },
  watch: {
    money: function() {
      this.finalmoney = this.money.toFixed(2);
    },
    checkedColor: function(val) {
      let style = document.createElement("style");
      style.innerHTML = `.el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: ${val} !important;
        border-color: ${val} !important;
      }`;
      document.head.appendChild(style);
    },
    "obj.searchVal": {
      handler(newv, olav) {
        this.page.curpage = 1;
        this.getAllOrder({
          totalPage: 0,
          curpage: 1,
          size: 10
        });
      }
    },
    dayFil: {
      handler() {
        const m1 = dayjs()
          .startOf("month")
          .format("YYYY-MM-DD HH:mm:ss"); //月初
        const m2 = dayjs()
          .endOf("month")
          .format("YYYY-MM-DD HH:mm:ss"); //月末
        const d1 = dayjs()
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"); //今日初
        const d2 = dayjs()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss"); //今日末
        const w1 = dayjs()
          .startOf("week")
          .format("YYYY-MM-DD HH:mm:ss"); //本周初
        const w2 = dayjs()
          .endOf("week")
          .format("YYYY-MM-DD HH:mm:ss"); //本月末
        const l1 = dayjs()
          .subtract(1, "day")
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss"); //昨日初
        const l2 = dayjs()
          .subtract(1, "day")
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss"); //昨日末
        // console.log(121);
        switch (this.dayFil) {
          case "1":
            this.duration = [d1, d2];
            break;
          case "2":
            this.duration = [l1, l2];
            break;
          case "3":
            this.duration = [w1, w2];
            break;
          case "4":
            this.duration = [m1, m2];
            break;
          default:
            break;
        }
      },
      immediate: true
    },
    finalmoney() {
      this.limitInput();
    }
  },
  methods: {
    limitInput() {
      this.finalmoney =
        ("" + this.finalmoney) // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
    },
    // 获取当前年月日时分秒
    getNowTime() {
      function formatNumber(num) {
        return num < 10 ? `0${num}` : `${num}`;
      }

      const now = new Date();
      const year = now.getFullYear();
      const month = formatNumber(now.getMonth() + 1);
      const day = formatNumber(now.getDate());
      const hour = formatNumber(now.getHours());
      const minute = formatNumber(now.getMinutes());
      const second = formatNumber(now.getSeconds());
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    // 获取支付类型
    getPayType() {
      return this.curDetai.order.pay_type === "balance"
        ? "余额支付"
        : this.curDetai.order.pay_type === "wechat"
        ? "微信支付"
        : this.curDetai.order.pay_type === "alipay"
        ? "支付宝支付"
        : this.curDetai.order.pay_type === "cash"
        ? "现金支付"
        : "";
    },
    contentSelect(key) {
      let user;
      if (localStorage.getItem("userInfo")) {
        user = JSON.parse(localStorage.getItem("userInfo")).name;
      }
      let mobile = "";
      this.other.boxList.forEach(item => {
        if (item.field_name == "mobile") {
          mobile = item.value;
        }
      });
      // let changeNum =
      //   this.payInfo.payType == 1
      //     ? Number(this.actualPayment - this.priceInfo.finalPrice).toFixed(1)
      //     : 0;
      let headerName = "";
      this.header.boxList.forEach(item => {
        if (item.field_name === "header" && item.checked) {
          headerName = item.value;
        }
      });
      let tempArr = [
        { label: "cashier_id", content: user }, //收银员
        { label: "deal_time", content: this.getNowTime() },
        { label: "deal_type", content: this.getPayType() }, //支付类型
        { label: "header", content: headerName },
        { label: "headerdesc", content: "中原地区最大的连锁型超市" },
        { label: "machine_no", content: "暂无，需提供" }, //机器号
        { label: "ord_bh", content: this.curDetai.order.ord_bh }, //订单号
        { label: "print_time", content: this.getNowTime() },
        {
          label: "goods_num",
          content: this.curOrder.api_items && this.curOrder.api_items.length
        },
        { label: "zongjine", content: this.curDetai.order.pay_price },
        { label: "shifujine", content: this.curDetai.order.pay_price }, //
        {
          label: "change",
          content: 0
        },
        { label: "zhifufangshi", content: this.getPayType() },
        { label: "payprice", content: this.curDetai.order.pay_price },
        { label: "serialnumber", content: "暂无" }, //流水号
        { label: "state", content: "说点啥呢？" },
        { label: "mobile", content: mobile }, //客服电话待确认
        { label: "mini_qr_code_desc", content: "万象优鲜小程序" },
        { label: "bill_qr_code_desc", content: "发票介绍是啥呢？" },
        { label: "bill_qr_code_check", content: "发票二维码" }, //发票二维码
        { label: "print_time", content: "2023.02.23 12:00:00" },
        { label: "origin", content: "" }, //产地
        { label: "spec", content: "只/元" },
        { label: "unit", content: "只" },
        { label: "level", content: "特级" },
        { label: "sale_price", content: "零售价" }
      ];
      tempArr = tempArr.filter(item => {
        return item.label === key;
      });
      return tempArr.length > 0 ? tempArr[0].content : "描述文字";
    },
    // 获取打印机名称
    async getPrinterName() {
      const res = await getReceiptField();
      if (res.code === 200) {
        // 表头
        this.header.boxList = res.data.field.header;
        // 商品基础信息
        this.goods.boxList = res.data.field.goods;
        // 结算信息
        this.settle.boxList = res.data.field.settle;
        // 支付信息
        this.pay.boxList = res.data.field.pay;
        // 其他信息
        this.other.boxList = res.data.field.other;
        // 打印机
        this.form.printer = res.data.printer_name;
        // 默认打印份数
        this.form.count = res.data.printer_number;
        // 小票规格
        this.form.printer_spec = res.data.printer_spec;
        // 打印机
        this.form.printer = res.data.printer_name;
        // 默认打印份数
        this.form.count = res.data.printer_number;
        // 小票规格
        this.form.printer_spec = res.data.printer_spec;
        // 是否自动打印
        res.data.field.printer.forEach(item => {
          if (item.field_name == "is_auto_receipt") {
            // console.log(item, "is_auto_receipt");
            if (item.value == 1) {
              this.form.isAoto = 1;
            } else {
              this.form.isAoto = 0;
            }
          }
        });
      }
    },
    // 获取颜色设置
    async getColorConfig() {
      const res = await getColorConfig();
      if (res.code === 200) {
        res.data.forEach(item => {
          switch (item.name) {
            case "desk_color":
              // 收银台主体颜色
              this.checkedColor = item.value;
              break;
            default:
              break;
          }
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    load() {
      this.count += 2;
    },
    // 获取所有订单
    async getAllOrder(page) {
      let params = {
        mobile: this.obj.searchVal.length === 11 ? this.obj.searchVal : "",
        orderbh: this.obj.searchVal.length === 11 ? "" : this.obj.searchVal,
        start_time: this.obj.time[0] ? this.obj.time[0] : this.duration[0],
        end_time: this.obj.time[1] ? this.obj.time[1] : this.duration[1],
        status: this.obj.status,
        page: page.curpage,
        limit: page.size
      };
      const res = await getOrderList(params);
      if (res.code == 200) {
        this.page.totalPage = res.data.last_page;
        if (page.curpage === 1) {
          this.orderList = [...res.data.data];
        } else {
          this.orderList = [...this.orderList, ...res.data.data];
        }
        this.curOrder = this.orderList[0] || {};
        const res1 = await getOrderDetail(this.curOrder.id);
        if (res1.code === 200) {
          this.curDetai = res1.data;
        }
      }
      console.log("1212", this.curDetai.order);
    },
    //切换订单
    changeOrder(index) {
      console.log('changeOrder index==>', index);

      this.clickIndex = index;
      this.curOrder = this.orderList[index];
      getOrderDetail(this.orderList[index].id).then(res => {
        if (res.code === 200) {
          this.curDetai = res.data;
        }
      });
    },
    //点击筛选
    async search() {
      console.log("value1", this.value1, this.tabPosition, this.obj.status);
      console.log(this.duration);
      await this.getAllOrder({
        totalPage: 0,
        curpage: 1,
        size: 10
      });
      this.chooseDia = false;
      this.obj = {
        searchVal: "",
        time: [],
        status: ""
      };
      this.dayFil = "";
      this.duration = [];
    },
    //关闭筛选框
    closeFilter() {
      this.chooseDia = false;
      this.obj = {
        searchVal: "",
        time: [],
        status: ""
      };
      this.dayFil = "";
      this.duration = [];
    },
    // 选中退款项
    selectOne(selection, row) {
      // console.log(1,selection);
      this.select = [...selection];
    },
    //确认退款
    async confirm() {
      const res = await refund({
        money:
          this.select.length === this.activeItem.length ||
          this.select.length === 1
            ? this.finalmoney
            : "",
        reason:
          this.checkList === "其他原因" ? this.refund.textarea : this.checkList,
        refund_type: this.radio,
        refund_part:
          this.select.length === this.activeItem.length &&
          this.curDetai.order.status == 1
            ? "1"
            : "2",
        id:
          this.activeItem.length > 0 &&
          this.select.length === this.activeItem.length &&
          this.curDetai.order.status == 1
            ? this.curDetai.order.id
            : this.select.map(i => i.id).join(",")
      });
      if (res.code == 200) {
        this.$message.success("退款成功");
        this.isRefund = false;
        //获取所有订单
        this.getAllOrder({
          totalPage: 0,
          curpage: 1,
          size: 10
        });
        this.select = [];
      } else {
        this.$message.error(res.data.err_code_des);
      }
    },
    //下一页
    next() {
      this.page.curpage++;
      this.getAllOrder(this.page);
    },
    // 打印
    printInfo() {
      // this.showPrint = true;
      this.$nextTick(() => {
        // 组装打印参数
        // let positionVal = [];
        // positionVal.push({ value: "订单小票", font: 5, type: "header" });
        // positionVal.push({
        //   text: "下单时间:",
        //   value: this.time(this.curDetai.order.pay_time),
        //   type: "normal",
        // });
        // positionVal.push({
        //   text: "订单号:",
        //   value: this.curDetai.order.ord_bh,
        //   type: "normal",
        // });
        // positionVal.push({
        //   text: "收银员：",
        //   value: this.curOrder.cashier_name,
        //   type: "normal",
        // });
        // positionVal.push({ value: "商品信息", font: 5, type: "header" });
        // positionVal.push({
        //   text: "商品名称/单价/重量/数量/小计",
        //   type: "split",
        // });
        // this.curOrder.api_items.forEach((item) => {
        //   let tableName =
        //     item.goods_name +
        //     "/¥" +
        //     item.single_price +
        //     item.spec_name +
        //     "/" +
        //     item.buy_num +
        //     item.spec_name +
        //     "/" +
        //     item.sum_money +
        //     "/";
        //   positionVal.push({
        //     text: tableName,
        //     type: "split",
        //   });
        // });
        // positionVal.push({ value: "结算信息", font: 5, type: "header" });
        // if (this.curDetai.order) {
        //   positionVal.push({
        //     text: "订单实付",
        //     value: "¥" + this.curDetai.order.pay_price,
        //     type: "normal",
        //   });
        //   positionVal.push({
        //     text: "付款方式",
        //     value:
        //       this.curDetai.order.pay_type === "balance"
        //         ? "余额"
        //         : this.curDetai.order.pay_type === "wechat"
        //         ? "微信"
        //         : this.curDetai.order.pay_type === "alipay"
        //         ? "支付宝"
        //         : this.curDetai.order.pay_type === "cash"
        //         ? "现金"
        //         : "",
        //     type: "normal",
        //   });
        //   positionVal.push({
        //     text: "优惠合计",
        //     value: "¥" + this.curDetai.order.order_discount_money,
        //     type: "normal",
        //   });
        //   positionVal.push({
        //     text: "优惠券",
        //     value: "¥" + this.curDetai.order.coupon_money,
        //     type: "normal",
        //   });
        //   positionVal.push({
        //     text: "折扣",
        //     value: this.curDetai.order.order_discount
        //       ? this.curDetai.order.order_discount
        //       : "-",
        //     type: "normal",
        //   });
        //   positionVal.push({
        //     text: "抹零",
        //     value: "¥" + this.curDetai.order.zero_money,
        //     type: "normal",
        //   });
        // }
        // positionVal.push({ value: "会员信息", font: 5, type: "header" });
        // positionVal.push({
        //   text: "会员手机",
        //   value: this.curDetai.member.mobile || "",
        //   type: "normal",
        // });
        // positionVal.push({
        //   text: "会员余额",
        //   value: "¥" + (this.curDetai.member.money || ""),
        //   type: "normal",
        // });
        // positionVal.push({
        //   text: "剩余积分",
        //   value: this.curDetai.member ? this.curDetai.member.score : "0",
        //   type: "normal",
        // });
        // if (this.refundItem.length > 0) {
        //   positionVal.push({ value: "退款信息", font: 5, type: "header" });
        //   this.refundItem.forEach((item) => {
        //     positionVal.push({
        //       text: "退款商品",
        //       value: item.goods_name,
        //       type: "normal",
        //     });
        //     positionVal.push({
        //       text: "退款金额",
        //       value: "¥" + item.refund_money,
        //       type: "normal",
        //     });
        //     positionVal.push({
        //       text: "退款方式",
        //       value:
        //         item.refund_way === 1
        //           ? "原路退回"
        //           : item.refund_way === 2
        //           ? "现金"
        //           : "",
        //       type: "normal",
        //     });
        //     positionVal.push({
        //       text: "退款原因",
        //       value: item.reason,
        //       type: "normal",
        //     });
        //     positionVal.push({
        //       text: "退款时间",
        //       value: this.time(item.refund_time),
        //       type: "normal",
        //     });
        //   });
        // }
        // this.printInfo();
        // 打印
        this.other.boxList.forEach(item => {
          if (item.field_name == "bill_qr_code_check") {
            item.value = "暂无发票地址";
          }
        });
        let positionVal = [];
        this.header.boxList.forEach(item => {
          if (item.field_name === "header" && item.checked) {
            positionVal.push({
              value: "万象优鲜",
              font: 5,
              type: "header"
            });
          }
          if (item.field_name != "header" && item.checked) {
            positionVal.push({
              text: item.flield_name,
              value: this.contentSelect(item.field_name).toString(),
              type: "normal"
            });
          }
        });
        let tablename = "";
        this.goods.boxList.forEach(item => {
          if (item.field_name === "goods_name" && item.checked === true) {
            tablename += "商品名称/";
          }
          if (item.field_name === "goods_danjia" && item.checked === true) {
            tablename += "单价/";
          }
          if (item.field_name === "goods_shuliang" && item.checked === true) {
            tablename += "数量/";
          }
          if (item.field_name === "goods_jiage" && item.checked === true) {
            tablename += "价格/";
          }
        });
        positionVal.push({
          text: tablename,
          type: "split"
        });
        this.curOrder.api_items.forEach((num1, index) => {
          let num = { ...num1 };
          let tablename2 = "";
          this.goods.boxList.forEach(item => {
            if (item.field_name === "goods_name" && item.checked === true) {
              tablename2 = tablename2 + num.goods_name + "/";
            }
            if (item.field_name === "goods_danjia" && item.checked === true) {
              tablename2 = tablename2 + num.single_price + "/";
            }
            if (item.field_name === "goods_shuliang" && item.checked === true) {
              tablename2 = tablename2 + num.buy_num + "/";
            }
            if (item.field_name === "goods_jiage" && item.checked === true) {
              tablename2 = tablename2 + num.sum_money + "/";
            }
          });
          positionVal.push({
            text: tablename2,
            type: "split"
          });
        });
        this.goods.boxList.forEach(item => {
          if (item.field_name === "goods_spec" && item.checked === true) {
            positionVal.push({
              text: "规格",
              value: "暂无",
              type: "normal"
            });
          }
          if (item.field_name === "item_no" && item.checked === true) {
            positionVal.push({
              text: "商品货号：",
              value: item.goods_barcode || "",
              type: "normal"
            });
          }
          if (item.field_name === "goods_zongshu" && item.checked === true) {
            positionVal.push({
              text: "商品总数:",
              value: this.curOrder.api_items.length.toString(),
              type: "normal"
            });
          }
          if (item.field_name === "goods_sales" && item.checked === true) {
            positionVal.push({
              text: "商品优惠:",
              value: "",
              // Number(this.preferential).toFixed(1) +"元"
              type: "normal"
            });
          }
          if (item.field_name === "sales_total" && item.checked === true) {
            positionVal.push({
              text: "优惠合计:",
              value: "",
              // Number(this.preferential).toFixed(1) + "元"
              type: "normal"
            });
          }
        });
        this.settle.boxList.forEach(item => {
          if (item.field_name != "bar_code" && item.checked === true) {
            console.log(
              this.contentSelect(item.field_name),
              item.field_name,
              "this.contentSelect(item.field_name)"
            );
            positionVal.push({
              text: item.flield_name,
              value: this.contentSelect(item.field_name).toString(),
              type: "normal"
            });
          }
        });
        positionVal.push({
          value: this.curDetai.order.ord_bh,
          font: 1,
          type: "tiaoma"
        });
        this.pay.boxList.forEach(item => {
          if (item.checked) {
            positionVal.push({
              text: item.flield_name,
              value: this.contentSelect(item.field_name).toString(),
              type: "normal"
            });
          }
        });
        this.other.boxList.forEach((item, index) => {
          if (item.checked) {
            if (
              item.field_name == "mini_qr_code_check" ||
              item.field_name == "bill_qr_code_check"
            ) {
              positionVal.push({
                text: item.flield_name,
                value: item.value,
                font: 0,
                type: "qr"
              });
            } else {
              positionVal.push({
                text: item.flield_name,
                value: this.contentSelect(item.field_name).toString(),
                type: "normal"
              });
            }
          }
        });
        console.log(positionVal, "positionValpositionVal");
        let isOnline = window.getPrintStatus(this.form.printer)
          ? window.getPrintStatus(this.form.printer)
          : false;
        if (isOnline && isOnline == "online") {
          this.loading = Loading.service({
            lock: true,
            spinner: "el-icon-loading",
            customClass: "all-body-loading",
            text: "打印中..."
          });
          let printIfno = {
            //------这里用用于打印  打印的展示信息
            name: "订单小票",
            type: 0,
            SType: "dingdan",
            w: parseInt(this.form.printer_spec.slice(0, -2)).toString(),
            h: (positionVal.length * 20).toString(),
            copies: this.form.count
          };
          let infoP = tiaoma({
            info: printIfno,
            position: positionVal
          });
          let JSONStr = JSON.stringify(infoP);
          console.log("传给C的打印数据：", infoP);
          window.wxPrint(JSONStr);
          setTimeout(() => {
            this.showPrint = false;
            this.loading.close();
            this.loading = null;
          }, 1000);
        } else {
          this.$message.error("打印机未连接");
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.sub {
  width: 100%;
  height: 100vh;
  background: #f4f6f7;
  display: flex;
  font-size: 14px;
  .list {
    width: 441px;
    height: 100vh;
    background: #fff;
    // overflow-y: scroll;

    .findList {
      width: 100%;
      height: 60px;
      padding: 10px 20px 10px 10px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;

      .intKuang {
        width: 330px;
        height: 42px;
        border-radius: 4px;
        overflow: hidden;
        background: #f5f6f7;

        input {
          width: 100%;
          height: 40px;
          border: none;
          background: #f5f6f7;
          padding-left: 20px;
          outline: none;
          font-size: 16px;
        }
      }

      .choose {
        span {
          vertical-align: middle;
          display: inline-block;
          margin-top: 10px;
          font-size: 16px;
        }

        img {
          vertical-align: middle;
          // margin-left: 20px;
          margin-top: 10px;
        }
      }
    }

    .orderList {
      width: 100%;
      height: calc(100vh - 90px);
      overflow-y: scroll;
      ul {
        li {
          list-style: none;
          padding: 16px 16px;
          box-sizing: border-box;
          border-bottom: 1px solid #f2f2f2;

          .itemTop {
            margin-bottom: 8px;

            img {
              vertical-align: middle;
            }

            span {
              vertical-align: middle;
              font-size: 16px;
              color: #1f2d23;
              // margin-left: 8px;
            }
          }

          .itemMiddel {
            font-size: 16px;
            margin-bottom: 8px;
          }

          .itemButtom {
            .num {
              font-size: 16px;
            }

            .price {
              font-size: 18px;
              font-weight: 800;
              // margin-right: 137px;
            }

            .time {
              font-size: 14px;
              color: #989ea7;
              float: right;

              img {
                vertical-align: middle;
              }

              span {
                vertical-align: middle;
              }
            }
          }
        }

        .clickColor {
          background: #f7f9fa;
        }
      }
    }
    .page {
      width: 100%;
      height: 20px;
      display: flex;
      justify-content: space-between;
    }
  }

  .goodsDetail {
    flex: 1;
    height: 100vh;
    background: #fff;
    border-left: 1px solid #f2f2f2;
    padding: 20px 0;
    box-sizing: border-box;
    overflow: hidden;

    .detailTop {
      width: 100%;
      background: #f7f9fa;
      padding: 6px 0 6px 7px;
      margin: 0 20px;
      margin-bottom: 20px;
      border-radius: 4px;

      img {
        vertical-align: middle;
      }

      span {
        vertical-align: middle;
        margin-left: 20px;
        font-size: 16px;
        color: #1f2d23;
      }
    }

    .detailInfo {
      width: 100%;
      height: calc(100% - 160px);
      margin: 0 20px;
      background: #fff;
      overflow: hidden;

      .leftInfo {
        width: 100%;
        height: 450px;
        overflow-y: auto;
        // float: left;

        .tit {
          width: 100%;
          height: 41px;
          line-height: 41px;
          background: #f7f9fa;
          border-radius: 4px;
          font-weight: 600;
          color: #060c1b;
          font-size: 18px;
          padding-left: 27px;
          box-sizing: border-box;
          position: relative;
          margin-bottom: 24px;
        }

        .tit::before {
          content: "";
          width: 3px;
          border-radius: 1px;
          background: @desk-color;
          height: 16px;
          position: absolute;
          top: 13px;
          left: 16px;
        }

        ul {
          li {
            list-style: none;
            margin-bottom: 24px;
            overflow: hidden;

            .goodsImg {
              float: left;
              margin-right: 16px;
              border-radius: 4px;
              border: 1px solid #f2f2f2;
              overflow: hidden;

              img {
                width: 80px;
                height: 80px;
              }
            }

            .goodsInfo {
              float: left;

              .name {
                color: #1f2d23;
                font-weight: 600;
                font-size: 18px;
                margin-bottom: 8px;
              }

              .price {
                font-size: 14px;
                margin-bottom: 8px;
                color: #1f2d23;
              }

              .heavy {
                font-size: 14px;
                color: #1f2d23;
              }
            }

            .goodsPrice {
              color: #1f2d23;
              font-weight: 600;
              font-size: 18px;
              float: right;
              margin-top: 55px;
            }
          }
        }
      }

      .shu {
        width: 1px;
        height: 100%;
        background: #f2f2f2;
        // float: left;
        margin: 0 28px;
      }

      .rightInfo {
        width: 100%;
        height: 450px;
        overflow-y: auto;
        // float: left;

        .tit {
          width: 100%;
          height: 41px;
          line-height: 41px;
          background: #f7f9fa;
          border-radius: 4px;
          font-weight: 600;
          color: #060c1b;
          font-size: 18px;
          padding-left: 27px;
          box-sizing: border-box;
          position: relative;
          margin-bottom: 24px;
        }

        .tit::before {
          content: "";
          width: 3px;
          border-radius: 1px;
          background: @desk-color;
          height: 16px;
          position: absolute;
          top: 13px;
          left: 16px;
        }

        .order {
          margin-bottom: 24px;

          p {
            font-size: 14px;
            color: #1f2d23;
            margin-bottom: 6px;

            .oKey {
              margin-right: 106px;
            }
          }

          .oTit {
            .oKey {
              font-size: 16px;
              font-weight: 600;
              margin-right: 98px;
            }

            .oVal {
              font-size: 16px;
              color: @desk-font-color;
            }
          }
        }

        .discounts {
          margin-bottom: 24px;

          p {
            font-size: 14px;
            color: #1f2d23;
            margin-bottom: 6px;
          }

          .oTit {
            .oKey {
              font-size: 16px;
              font-weight: 600;
              margin-right: 98px;
            }

            .oVal {
              font-size: 16px;
              color: @desk-font-color;
            }
          }
        }

        .member {
          margin-bottom: 24px;

          p {
            font-size: 14px;
            color: #1f2d23;
            margin-bottom: 6px;

            .oKey {
              margin-right: 106px;
            }
          }

          .oTit {
            .oKey {
              font-size: 16px;
              font-weight: 600;
            }

            .oVal {
              font-size: 16px;
              color: @desk-font-color;
            }
          }
        }

        .refund {
          p {
            font-size: 14px;
            color: #1f2d23;
            margin-bottom: 6px;

            .oKey {
              margin-right: 106px;
            }
          }

          .oTit {
            .oKey {
              font-size: 16px;
              font-weight: 600;
            }

            .oVal {
              font-size: 16px;
              color: @desk-font-color;
            }
          }
        }
      }
    }

    .handle {
      width: 100%;
      height: 80px;
      padding-top: 16px;
      box-sizing: border-box;
      background: yellow;
      background: #ffffff;
      box-shadow: 0px 0px 6px 0px #ebeced;
      text-align: right;

      button {
        width: 136px;
        height: 48px;
        background: @desk-color;
        border-radius: 4px;
        font-size: 18px;
        color: #ffffff;
        border: none;
        cursor: pointer;
        margin-right: 20px;
      }
    }
  }
}
// 打印
.print-box {
  font-size: 22px;
  position: absolute;
  width: 365px;
  padding: 20px;
  padding-top: 20px;
  padding-left: 0px;
  left: 0px;
  top: 10px;
  display: flex;
  flex-direction: column;
  line-height: 30px;
  background: #fff;
  .print-title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 26px;
    padding-top: 20px;
    font-weight: 600;
  }
  .border-b {
    border-bottom: 1px solid #333;
  }
  .print-out {
    display: flex;
    flex-direction: column;
    .item-print {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .print-label {
        font-weight: 600;
      }
      .print-content {
        font-weight: 600;
      }
    }
  }
}
.refundSub {
  width: 100%;
  height: 100vh;
  background: #f4f6f7;
  display: flex;

  .refundLeft {
    width: 441px;
    height: 100vh;
    background: #fff;
    margin-right: 12px;
  }

  .refundright {
    flex: 1;
    height: 100vh;
    background: #fff;

    .oheader {
      height: calc(100vh - 82px);
      padding: 20px;
      box-sizing: border-box;

      .detailHead {
        width: 100%;
        background: #f7f9fa;
        padding: 6px 32px;
        box-sizing: border-box;
        margin-bottom: 40px;
        border-radius: 4px;

        ul {
          display: flex;
          flex-wrap: wrap;
          // justify-content: space-between;
          overflow: hidden;

          li {
            list-style: none;
            font-size: 16px;
            color: #1f2d23;

            margin: 8px 0;
            margin-right: 30px;
            // float: left;
            // ma
          }
        }
      }

      .detailBody {
        ul {
          li {
            list-style: none;
            margin-bottom: 25px;

            .tit {
              margin-bottom: 10px;
              font-size: 16px;
              color: #1f2d23;
            }
          }
        }
      }
    }
  }

  .detailFooter {
    width: 100%;
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 0px #ebeced;
    text-align: right;

    .cancel,
    .affirm {
      width: 136px;
      height: 48px;
      border-radius: 4px;
      font-size: 18px;
      outline: none;
      cursor: pointer;
      border: 2px solid @desk-color;
      margin-top: 16px;
    }

    .cancel {
      background: #fff;
      color: @desk-font-color;
      margin-right: 12px;
    }

    .affirm {
      background: @desk-color;
      color: #fff;
      margin-right: 20px;
    }
  }
}
/deep/ .is-active::after {
  content: "";
  width: 0;
}
.chooseDia {
  box-sizing: border-box;
  .tit {
    margin-bottom: 14px;
    font-size: 18px;
  }
}
/deep/ .el-radio__label {
  font-size: 16px;
}
/deep/.el-input {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/order.vue